import React from 'react';
import PropTypes from 'prop-types';
import AppointmentsList from '../../../../appointments/appointmentsList';

const Appointments = ({ barberAppointments, barberId }) => (
  <div className="u-height-510 u-mv">
    <AppointmentsList
      appointments={barberAppointments}
      type="barber"
      barberId={barberId}
    />
  </div>
);

Appointments.propTypes = {
  barberAppointments: PropTypes.arrayOf(PropTypes.object).isRequired,
  barberId: PropTypes.string,
};
Appointments.defaultProps = {
  barberId: null,
};

export default Appointments;
